<template>
<div class="wenjuan-template">
    <div class="option-actions" v-if="!disabled">
        <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addOption">添加选项</el-button>
    </div>
    <div v-for="(question, index) in localQuestions" :key="index" class="question-item">
        <div class="question-header">
            <el-tag>{{ index + 1 }}</el-tag>
            <el-select :disabled = "disabled" size="small" @change="(val) => updateSelect(val,index)" v-model="question.name">
                <el-option v-for="item in itemType" :value="item.name" :label="item.label"></el-option>
            </el-select>

            <el-input :disabled = "disabled" v-model="question.label" @change="updateQuestion" size="small" />

            <el-button
            v-if="!disabled"
            @click="changeRequired(index)" 
            size="mini" 
            :type="question.required ? 'success' : 'info'" 
            icon="el-icon-open" 
            circle
            ></el-button>

            <el-button
                v-if="!disabled"
                type="danger"
                @click="removeQuestion(index)"
                size="mini"
                icon="el-icon-delete"
                circle
            />
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['value','disabled'],
    data() {
        return {
            localQuestions: this.parseQuestions(this.value),
            itemType: [
                {"name":"name","label":"姓名","type":"text"},
                {"name":"idCard","label":"身份证","type":"text"},
                // {"name":"nickName","label":"昵称","type":"text"},
                // {"name":"head","label":"头像","type":"image"},
                // {"name":"mobile","label":"手机号","type":"text"},
                {"name":"email","label":"邮箱","type":"text"},
                {"name":"education","label":"学历","type":"education"},
                {"name":"vocation","label":"职业","type":"career"},                
                {"name":"income","label":"收入","type":"income"},
                {"name":"mobileBrands","label":"手机品牌","type":"phone_brand"},                
                {"name":"province","label":"所在地","type":"address"},
            ]
        }
    },
    methods: {
        init() {
            this.localQuestions = this.localQuestions.filter(item => item.name && String(item.name).trim() !== '');
        },
        parseQuestions(value) {
            try {
                const parsed = JSON.parse(value);
                if (typeof parsed === 'object' && parsed !== null) {
                    return parsed;
                }
                throw new Error();
            } catch {
                return [];
            }
        },
        updateQuestion() {
            this.localQuestions.forEach((item, index) => {
                this.$set(item, 'id', index + 1);
            });
            this.$emit('input', JSON.stringify(this.localQuestions))
        },
        updateSelect(selectedName,index) {
            const selectedItem = this.itemType.find(item => item.name === selectedName);
            if (selectedItem) {
                this.localQuestions[index].label = selectedItem.label;
                this.localQuestions[index].type = selectedItem.type;
                this.updateQuestion()
            }
        },
        addOption() {
            this.localQuestions.push({
                name: "",
                label: "",
                type: "",
                required: true
            })
        },
        changeRequired (index){
            this.localQuestions[index].required = !this.localQuestions[index].required
            this.updateQuestion()
        },
        removeQuestion(index) {
            this.$confirm('确定删除该问题吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.localQuestions.splice(index, 1)
                this.updateQuestion()
            }).catch(() => {
            });
        },
    },
    watch: {
      value: {
        handler(newVal) {
            this.localQuestions = this.parseQuestions(newVal)
        },
        deep: true
      }
    }
}
</script>

<style scoped>
.question-item {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #eee;
}
.question-header {
    display: flex;
    align-items: center;
    gap: 10px;
}
.question-header button{
    margin: 0;
}
</style>